import React from 'react';
import { connect } from 'react-redux'
import { SvgCloseIcon } from '../svg';
import { setQuestionAnswer } from '../../api/questionnaires/actions'




class ConditionalModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            answers: {}
        }

        this.setComponentAnswers = this.setComponentAnswers.bind(this)
    }

    componentDidMount(){
        const questions = (this.props.question && this.props.question[0] && this.props.question[0].conditional_question) || [];
        this.initializeAnswersFromQuestions(questions)
    }

    componentDidUpdate(prevProps) {
        if (this.props.question !== prevProps.question) {
            const questions = (this.props.question && this.props.question[0] && this.props.question[0].conditional_question) || [];
            this.initializeAnswersFromQuestions(questions)
        }
    }

    initializeAnswersFromQuestions(questions) {
        if (!questions.length) {
            return;
        }
        const answers = { ...this.state.answers };
        let shouldUpdate = false;

        questions.forEach((question) => {
            const key = question.id;
            if (key === undefined) {
                return;
            }
            if (answers[key] === undefined) {
                answers[key] = '';
                shouldUpdate = true;
            }
        });

        if (shouldUpdate) {
            this.setState({ answers });
        }
    }

    shouldBeDisabled(questions){
        const condition_check = this.props.question[0].condition;
        let counter = 0
        let lastKey = questions[questions.length - 1].id;
        Object.keys(this.state.answers).forEach((key) => {
            if (this.state.answers[key] == '') {
                counter -= 1 
            }
            counter += 1
        });
        switch (condition_check) {
            case "allTrue":
                return !(counter == questions.length)
            case "anyTrue":
                return !(counter > 0);
            case "allFalse":
                return !(counter === 0)
            case "anyFalse":
                return !(counter < questions.length)
            case "lastTrue":
                return !(this.state.answers[lastKey] && this.state.answers[lastKey] !== '')
        }
    }


    setAnswer(id, e) {
        this.setState({
            answers :{
                ...this.state.answers,
                [id]: e.target.value
            }
        })
    }

    selectCheckbox(id, label){
        this.setState({
            answers :{
                ...this.state.answers,
                [id]: label
            }
        })
    }


    shouldBeChecked(id, labelOrId) {
        return this.state.answers[id] === labelOrId
	}

    renderOneSingleLineQuestion(q, id) {
		let label = (q.label == "NONE" ? "" : q.label)
		return (<>
            <div className="question-wrapper">
                <label className={`question${this.getQuestionValue(id) ? ' error' : ''}`} htmlFor={id}>{label}{q.tooltip && <>&nbsp;<Tooltip text={q.tooltip} /></>}</label>
                <input className="answer input" type="text" id={id} onChange={(e) => this.setAnswer(id, e)} value={this.getQuestionValue(id) ? this.getQuestionValue(id) : ""}></input>
            </div>
		</>)
	}


    isQuestionUnanswered(id){
        return false
    }

    getQuestionValue(id){
        return this.state.answers[id]
    }

    renderCheckboxes(question, id) {
        const questions = question.value[0].condition;
		return <>
            <div className="question-wrapper border-0 pt-2 pb-2">
            <label className={`question-${question.id}`} htmlFor={question.id}>{question.value[0].label}{question.tooltip && <>&nbsp;<Tooltip text={question.tooltip} /></>}</label>
			{ questions.map((q, index) => {
                return <div className={`qa radio${this.isQuestionUnanswered(id) ? ' error' : ''}`}>
                    <div className="answer radio">
                        <div className="checkbox">
                            <input type="checkbox" id={id} checked={this.shouldBeChecked(id, q.label)} defaultChecked={this.shouldBeChecked(id, q.label)} name={q.label} value={this.shouldBeChecked(id, q.label)} onChange={(e) => this.selectCheckbox(id, q.label)}></input>
                            <label className="pl-5" htmlFor={id}>{q.label}</label>
                        </div>
                    </div>
                </div>
            })
			}
            </div>
		</>
	}

    renderSingleLineQuestion(q, index){
		return (<>
            <div className="question-wrapper d-flex border-0 pt-2 pb-2">
                <label className={`question${this.getQuestionValue(q.id) ? ' error' : ''}`} htmlFor={q.id}>{q.value.label}{q.tooltip && <>&nbsp;<Tooltip text={q.tooltip} /></>}</label>
                <input className="answer input col" type="text" id={q.id} onChange={(e) => this.setAnswer(q.id, e)} value={this.getQuestionValue(q.id) ? this.getQuestionValue(q.id) : ""}></input>
            </div>
		</>)
    }

    renderQuestion(question, index) {
        switch (question.type) {
            case 'conditional_date':
            case 'conditional_question':
                return this.renderSingleLineQuestion(question, index)
            case 'conditional_text':
                return <div>{question.value.label}</div>
            case 'conditional_checkboxes':
                return this.renderCheckboxes(question, question.id)
            default:
                return <div>Type {question.type} not supported</div>
        }
    }

    setComponentAnswers(){
        let id = this.props.questionId;               // Parent question-block ID
        this.props.addMultiAnswer(id, this.state.answers)
        this.setState({
            answers: {}
        })
        // this.props.dispatch(setQuestionAnswer(id, this.state.answer, customerId, questionnaireId))
    }

    render() {
        let questions = this.props.question[0].conditional_question;           // Conditional questions
        let qId = this.props.questionId;                // "Upper" question ID
   
        return (

            <div className="modal conditional-modal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" id={this.props.id}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            {/* <SvgCloseIcon/> */}
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><SvgCloseIcon/></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            { questions.map((item, index) => 
                                this.renderQuestion(item, index)
                            )}
                            <button disabled={this.shouldBeDisabled(questions)} className="btn btn-primary my-4" type="button" onClick={(e) => this.setComponentAnswers()} data-dismiss="modal">Vista</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ConditionalModal;
